import { Alert, AlertTitle, Box, Grid, IconButton, Typography } from '@mui/material';
import React, { Component } from 'react';
import Dialog from '../../../common/Dialog';
import InputText, { InputSelectNative } from '../../../common/Form';
import DatePickerCmp from '../../../common/DatePicker';
import { GroupRadio, SingleRadio } from '../../../common/RadioAndCheckbox';
import PhotoUpload from '../../../common/PhotoUpload';
import Creatable from '../../../common/Creatable';
import { isEmpty } from 'lodash';
import { Fragment } from 'react';
import { QrCodeScannerRounded, ScannerRounded } from '@mui/icons-material';
import ScanQrCode from './ScanQrCode';

const HEADER = {
    "immo" : "Immobilisation",
    "materiel" : "Matériel",
    "car" : "Véhicule",
}

class Attribution extends Component {
    state = { 
        loan_start_date: new Date(),
        loan_estimated_return: new Date(),
        loan_km_start: "",
        loan_fuel_start: "",
        loan_photo_back_start: null,
        loan_photo_front_start: null,
        loan_photo_top_start: null,
        loan_photo_bottom_start: null,
        loan_photo_left_start: null,
        loan_photo_right_start: null,
        loan_user: this.props.loan ? this.props.loan.loan_user : "",
        loan_userDisplay: this.props.loan && this.props.loan.loan_user ? {
            value: this.props.loan.loan_user, 
            label: this.props.USERS[this.props.loan.loan_user].user_name
        } : {value:"", label:""},

        loan_equipement: this.props.loan ? this.props.loan.loan_equipement : "",
        loan_equipementDisplay: this.props.loan && this.props.loan.loan_equipement ? {
            value: this.props.loan.loan_equipement, 
            label: this.props.EQUIPEMENTS[this.props.loan.loan_equipement].loan_name
        } : {value:"", label:""},

        loan_vehicule: this.props.loan ? this.props.loan.loan_vehicule : "",
        loan_vehiculeDisplay: this.props.loan && this.props.loan.loan_vehicule ? {
            value: this.props.loan.loan_vehicule, 
            label: this.props.EQUIPEMENTS[this.props.loan.loan_vehicule].loan_name
        } : {value:"", label:""},

        loan_equipement_type: "",
        loan_prev_usage: "",
        equipement_remarks_start: "",
        resa_remarks: "",
        equipement_state_start: "",
        errors:{
            loan_start_date: "",
            loan_estimated_return: "",
            loan_ref: "",
            loan_user: "",
            loan_km_start: "",
            loan_fuel_start: "",
            loan_user:"",
            
            loan_photo_back_start: "",
            loan_photo_front_start: "",
            loan_photo_top_start: "",
            loan_photo_bottom_start: "",
            loan_photo_left_start: "",
            loan_photo_right_start: "",
            loan_equipement: "",
            loan_vehicule: "",
            loan_equipement_type: "",
            loan_prev_usage: "",

        },
        is_permanent: "",
        openScan: false,
        currentEquipement: {},
        defaultDemandEquip: {
            equipement_ref: "",
            equipement_name: "",
            equipement_id: "",
        }
    }
    
    componentDidMount = () => {
        const { defaultItem, user, defaultItemDemand, EQUIPEMENTS, VEHICULES , savedLoan} = this.props;

        console.log('====================================');
        console.log({defaultItem, user});
        console.log('====================================');
        if(!this.props.STATE.equipements.fetched ){
            this.props.fetchEquipements()
        }
        if(!this.props.STATE.vehicules.fetched ){
            this.props.fetchVehicules()
        }

        if( user) {
            let option = {
                label: `${user.lastname.toUpperCase()} ${user.username}`,
                value: user.user_id
            }
            this.handleChangeSelect("loan_user", option)
        }
        if (!isEmpty(defaultItem)) {
            let option = {
                label: `${defaultItem.equipement_ref.toUpperCase()} | ${defaultItem.equipement_name}`,
                value: defaultItem.equipement_id,
                permanent: defaultItem.permanent_loan,
                equipement: defaultItem
                // short: item.short_loan
            }
            let equipType = defaultItem.equipement_type == "vehicule" ? "vehicule" : "equipement"
            this.setState({
                loan_equipement_type: equipType,
                currentEquipement: defaultItem
            })
            this.handleChangeSelect(`loan_${equipType}`, option)
        }
        if (!isEmpty(defaultItemDemand)) {
            let equip = EQUIPEMENTS[defaultItemDemand] ? EQUIPEMENTS[defaultItemDemand] : VEHICULES[defaultItemDemand]
            let equipType = equip.equipement_type == "vehicule" ? "vehicule" : "equipement"

            console.log('====================================');
            console.log({equip, defaultItemDemand, equipType});
            console.log('====================================');
            let option = {
                label: `${equip.equipement_ref.toUpperCase()} | ${equip.equipement_name}`,
                value: equip.equipement_id,
                permanent: equip.permanent_loan,
                equipement: equip
                // short: item.short_loan
            }
            this.setState({
                loan_equipement_type : equipType,
                defaultDemandEquip: equip,
                currentEquipement: equip
            })
            this.handleChangeSelect(`loan_${equipType}`, option)
            this.handleChangeDate("loan_start_date", new Date(this.props.start_date))
            this.handleChangeDate("loan_estimated_return", new Date(this.props.end_date))

        } else if (this.props.resa) {
            this.handleChangeDate("loan_start_date", new Date(this.props.start_date))
            this.handleChangeDate("loan_estimated_return", new Date(this.props.end_date))
            
        } else if (!isEmpty(savedLoan)) {
            let equip = savedLoan.equipement
            let equipType = equip.equipement_type == "vehicule" ? "vehicule" : "equipement"
            let option = {
                label: `${equip.equipement_ref.toUpperCase()} | ${equip.equipement_name}`,
                value: equip.equipement_id,
                permanent: equip.permanent_loan,
                equipement: equip
                // short: item.short_loan
            }
            this.setState({
                loan_equipement_type : equipType,
                defaultDemandEquip: equip,
                currentEquipement: equip
            })
            this.handleChangeSelect(`loan_${equipType}`, option)
            this.handleChangeDate("loan_start_date", new Date(savedLoan.loan_start_date))
            this.handleChangeDate("loan_estimated_return", new Date(savedLoan.loan_estimated_return))
        }

    }
    handleChange = (e) => {
        const { name, value} = e.target;
        // TO DO add regex float
        this.setState({
            [name]: value
        })
    }
    handleChangeCheck = (e) => {
        const { name, value} = e.target;
        
        
        this.setState({
            [name]: value,

            loan_equipement: "",
            loan_equipementDisplay: {value:"", label:""},
            loan_vehicule: "",
            loan_vehiculeDisplay: {value:"", label:""},

        })
    }

    handleChangeDate = (name, date) => {
        let newDate = date.setHours(0,0, 0, 0)
        this.setState({
            [name]: new Date(newDate)
        })
    }

    handleChangeSelect = (name, option) => {
        let is_permanent = this.state.is_permanent
        let currentEquipement = this.state.currentEquipement
        console.log('====================================');
        console.log({option});
        console.log('====================================');
        if(option){
            if (name !== "loan_user"){
                is_permanent = option.permanent
                currentEquipement = option.equipement
            }
            this.setState({
                [name]: option.value || "",
                [`${name}Display`]: option,
                is_permanent,
                currentEquipement
            })
        } else {
            this.setState({
                [name]: "",
                [`${name}Display`]: {},
                is_permanent,
                currentEquipement : {}
            })
        }
    }

    openScanner = () => {
       
        this.setState({
            openScan : true
        })
    }

    setPhotos = (name, list) => {
        console.log("[INFO] SETPHOTOS", name, list);
        
        this.setState({
            [name]:list
        })
    }

    validate = () => {
        let noError = true
        let errors = {} 
        let required = [
            "loan_user",   
            "loan_start_date",    
            "loan_equipement_type", 
            "equipement_state_start",
            "equipement_remarks_start",
            // "loan_estimated_return",
            "loan_photo_back_start",
            "loan_photo_front_start",
            "loan_photo_top_start",
            "loan_photo_bottom_start",
            "loan_photo_left_start",
            "loan_photo_right_start",

        ]
        if (this.props.resa) {
            required = [
                "loan_user",   
                "loan_start_date",    
                "loan_equipement_type",     
            ]
        }
        if (!this.state.is_permanent) {
            required = required.concat([
                "loan_estimated_return"
            ])
        }
            
        if( this.state.loan_equipement_type === "vehicule" ){
            if (this.props.resa) {
                required = required.concat([
                    "loan_vehicule",
                ])
            } else {
                required = required.concat([
                    "loan_vehicule",
                    "loan_km_start",
                    "loan_fuel_start",
                ])
            }
        } else {
            required = required.concat([
                "loan_equipement"
            ])
        }

        console.log('====================================');
        console.log({required});
        console.log('====================================');
        required.map(field => {
            if( !this.state[field] && isEmpty(this.state[field]) ) { // isEmpty doesn't work on dates, !doesn't work for arrays
                console.log(`${field} is empty`)
                noError =  false
                errors[field] = "Veuillez remplir ce Champ" 
            } else {
                errors[field] = "" 
            }
        })

        this.setState({
            errors
        })
        return noError
    }
    handleSubmit = async () => {
        const { max, currentIndex } = this.props;
        if( this.validate() ){
            let data = {}
            if (this.props.final && this.props.savedLoan) {
                data = Object.assign({}, this.props.savedLoan)
            }
            
            data.is_permanent = this.state.is_permanent // short || permanent
            data.loan_start_date = this.state.loan_start_date
            data.loan_user = this.state.loan_user
            data.loan_prev_usage = this.state.loan_prev_usage
            data.loan_equipement_type = this.state.loan_equipement_type
            data.resa_remarks = this.state.resa_remarks
            data.equipement_remarks_start = this.state.equipement_remarks_start
            data.equipement_state_start = this.state.equipement_state_start
            
            data.loan_photo_back_start = this.state.loan_photo_back_start
            data.loan_photo_front_start = this.state.loan_photo_front_start
            data.loan_photo_top_start = this.state.loan_photo_top_start
            data.loan_photo_bottom_start = this.state.loan_photo_bottom_start
            data.loan_photo_left_start = this.state.loan_photo_left_start
            data.loan_photo_right_start = this.state.loan_photo_right_start
            
            if (this.state.loan_equipement_type === "vehicule") {
                data.loan_km_start = parseFloat(this.state.loan_km_start)
                data.loan_fuel_start = parseFloat(this.state.loan_fuel_start)
                data.loan_vehicule = this.state.loan_vehicule
                data.loan_equipement = this.state.loan_vehicule
            } else {
                data.loan_equipement = this.state.loan_equipement
            }

            if (!this.state.is_permanent) {
                data.loan_estimated_return = this.state.loan_estimated_return
            }
            if(!isEmpty(this.props.demand_line)){
                data.from_demand_line = this.props.demand_line.demand_loan_line_id
                // data.from_demand = this.props.demand_line.demand_loan_id
            }
           
            
            console.log('====================================');
            console.log("submit loan", {data});
            console.log('====================================');
            
            if (this.props.resa) {
                await this.props.newLoanResa(data)
            } else if (this.props.final) {
                data.loan_status = "RESA_READY"
                await this.props.newLoan(data) // delete old and create new with same id
            } else {
                await this.props.newLoan(data)
            }

            // // if NoErrors ...
            if(this.props.STATE.loans.error){
                this.props.notif("error",`Un problème est survenu: ${this.props.STATE.loans.error}`)
            } else { 
                this.props.notif("success", "Reservation mise à jour")
                if(max && currentIndex) {
                    this.props.handleNext()
                } else {
                    this.props.handleClose()
                }
            }
        } else {
            this.props.notif("error", "Le formulaire contient des erreurs")
        }
    }

    deleteFromDemand = async () => {
        let newLoan = {}
        newLoan.loan_status = "RESA_CANCELED"
        newLoan.from_demand_line = this.props.demand_line.demand_loan_line_id

        await this.props.updateDeleteLineAdmin(newLoan)
        // notif success
        if(this.props.STATE.loans.error){
            this.props.notif("error",`Un problème est survenu: ${this.props.STATE.loans.error}`)
        } else { 
            this.props.notif("success", "Reservation mise à jour")
            this.props.handleClose()
        }
    }


    render() {
        console.log('====================================');
        console.log(this.state);
        console.log('====================================');
        const { USERS, EQUIPEMENTS, VEHICULES, defaultItemDemand, max, currentIndex } = this.props;
        const { openScan, defaultDemandEquip } = this.state;

        return (
            <Dialog
                title={max && currentIndex ? `Réserver un Équipement — ${currentIndex}/${max}` : `Attribuer un Équipement`}
                close={this.props.handleClose}
                appBar
                submitAction={this.handleSubmit}
                maxWidth="md"
                secondSubmitActionButton={this.props.resa && this.deleteFromDemand}
                submitSecondaryTitle="Retirer de la demande"
            >
                {openScan &&
                    <ScanQrCode 
                        handleClose={()=> this.setState({ openScan: false })}
                        title="Scanner un équipement"
                        VEHICULES={this.props.VEHICULES}
                        EQUIPEMENTS={this.props.EQUIPEMENTS}
                        LOANS={this.props.LOANS}
                        equipement_type={this.state.loan_equipement_type}
                        setEquipement={(option) => this.handleChangeSelect(`loan_${this.state.loan_equipement_type}`, option)}
                    />
                }
                <Grid container >
                    <Grid item xs={12}>
                        <Box p={1}>
                            <GroupRadio groupName="loan_equipement_type" value={this.state.loan_equipement_type}  onChange={this.handleChangeCheck} >
                                <SingleRadio 
                                    value="equipement" 
                                    checked={this.state.loan_equipement_type === "equipement" } 
                                    disabled={!isEmpty(this.props.defaultItem) && this.state.loan_equipement_type !== "equipement" } 
                                    label="Immo / Matériel" 
                                    />
                                <SingleRadio 
                                    value="vehicule" 
                                    checked={this.state.loan_equipement_type === "vehicule"} 
                                    disabled={!isEmpty(this.props.defaultItem) && this.state.loan_equipement_type !== "vehicule" } 
                                    label="Véhicule" 
                                />
                            </GroupRadio>
                        </Box>
                    </Grid>
                    
                    {this.state.loan_equipement_type === "equipement" && 
                        <Grid item xs={12}>
                            {!isEmpty(EQUIPEMENTS) && !isEmpty(Object.values(EQUIPEMENTS).filter(e => e.equipement_available)) ? 
                                <>
                                    {defaultItemDemand &&
                                    <Box>
                                        <Alert severity="info">
                                            <AlertTitle>Equipement Recommandé</AlertTitle>
                                            <b>{defaultDemandEquip.equipement_ref.toUpperCase()}</b> — {defaultDemandEquip.equipement_name}
                                        </Alert>
                                    </Box>
                                    }
                                    <Box style={{display:"flex"}}>
                                        <Creatable
                                            label="Équipement"
                                            required
                                            error={this.state.errors.loan_equipement}
                                            id="loan_equipement"
                                            labelWidth={100} 
                                            options={Object.values(EQUIPEMENTS).filter(e => e.equipement_available).map( item => ({
                                                label: `${item.equipement_ref.toUpperCase()} | ${item.equipement_name}`,
                                                value: item.equipement_id,
                                                permanent: item.permanent_loan,
                                                equipement: item
                                                // short: item.short_loan
                                            }))}
                                            value={this.state.loan_equipementDisplay}
                                            onChange={(option) => this.handleChangeSelect("loan_equipement", option)}
                                            disabled={!isEmpty(this.props.defaultItem) || this.props.final}
                                        />
                                        {isEmpty(this.props.defaultItem) && !this.props.final &&
                                            <IconButton onClick={this.openScanner} color="primary">
                                                <QrCodeScannerRounded />
                                            </IconButton>
                                        }
                                    </Box>
                                    {((defaultItemDemand && this.state.loan_equipement && EQUIPEMENTS[this.state.loan_equipement].duplicate_from != defaultDemandEquip.duplicate_from) || (this.props.resa && !defaultItemDemand)) &&
                                        <Box>
                                            <Alert severity="error">
                                                <AlertTitle>Changement d'équipement</AlertTitle>
                                            </Alert>
                                            <Box>
                                                <InputText
                                                    onChange={this.handleChange}
                                                    multiline
                                                    required
                                                    rows={2}
                                                    id="resa_remarks"
                                                    error={this.state.errors.resa_remarks}
                                                    value={this.state.resa_remarks}
                                                    name="resa_remarks"
                                                    label="Raisons du Changement"
                                                />
                                            </Box>
                                        </Box>
                                    }
                                </>
                                :
                                <Alert severity="warning">Aucun équipement disponible</Alert>
                            }
                        </Grid>
                    }
                    {this.state.loan_equipement_type === "vehicule" && 
                        <Grid item xs={12}>
                            {!isEmpty(VEHICULES) && !isEmpty(Object.values(VEHICULES).filter(e => e.equipement_available)) ?
                                <> 
                                    {defaultItemDemand &&
                                        <Box>
                                            <Alert severity="info">
                                                <AlertTitle>Equipement Recommandé</AlertTitle>
                                                <b>{defaultDemandEquip.equipement_ref.toUpperCase()}</b> — {defaultDemandEquip.equipement_name}
                                            </Alert>
                                        </Box>
                                    }
                                    <Box style={{display:"flex"}}>
                                        <>
                                            <Creatable
                                                label="Véhicule"
                                                required
                                                error={this.state.errors.loan_vehicule}
                                                id="loan_vehicule"
                                                labelWidth={100} 
                                                options={Object.values(VEHICULES).filter(e => e.equipement_available).map( item => ({
                                                    label: `${item.equipement_ref.toUpperCase()} | ${item.equipement_name}`,
                                                    value: item.equipement_id,
                                                    permanent: item.permanent_loan,
                                                    equipement: item
                                                        // short: item.short_loan
                                                }))}
                                                value={this.state.loan_vehiculeDisplay}
                                                onChange={(option) => this.handleChangeSelect("loan_vehicule", option)}
                                                disabled={!isEmpty(this.props.defaultItem) || this.props.final}
                                            />
                                            {isEmpty(this.props.defaultItem) &&  !this.props.final &&
                                                <IconButton onClick={this.openScanner} color="primary">
                                                    <QrCodeScannerRounded />
                                                </IconButton>
                                            }
                                            
                                        </>
                                    </Box>
                                    {((defaultItemDemand && this.state.loan_vehicule && VEHICULES[this.state.loan_vehicule].duplicate_from != defaultDemandEquip.duplicate_from) || (this.props.resa && !defaultItemDemand) )&&
                                        <Box>
                                            <Alert severity="error">
                                                <AlertTitle>Changement de materiel</AlertTitle>
                                            </Alert>
                                            <Box>
                                                <InputText
                                                    onChange={this.handleChange}
                                                    multiline
                                                    required
                                                    rows={2}
                                                    id="resa_remarks"
                                                    error={this.state.errors.resa_remarks}
                                                    value={this.state.resa_remarks}
                                                    name="resa_remarks"
                                                    label="Raisons du Changement"
                                                />
                                            </Box>
                                        </Box>
                                    }
                                </>
                            :
                                <Alert severity="warning">Aucun véhicule disponible</Alert>
                            }
                        </Grid>
                        
                    }
                    {(!isEmpty(this.state.loan_equipement) || !isEmpty(this.state.loan_vehicule)) &&
                        <Fragment>
                            <Grid item xs={12}>
                                <hr />
                                <Box p={1}>
                                    <Typography color="primary" variant="button" style={{fontWeight: "bold"}}>{this.state.is_permanent ? "Affectation Permanente" : "Emprunt"}</Typography>
                                </Box>
                            </Grid>
                            <Grid item xs={12}>
                                {!isEmpty(USERS) && 
                                    <Creatable
                                        label="Utilisateur"
                                        required
                                        error={this.state.errors.loan_user}
                                        id="loan_user"
                                        labelWidth={100} 
                                        options={Object.values(USERS).map( item => ({
                                            label: `${item.lastname.toUpperCase()} ${item.username}`,
                                            value: item.user_id
                                        }))}
                                        value={this.state.loan_userDisplay}
                                        onChange={(option) => this.handleChangeSelect("loan_user", option)}
                                        disabled={!isEmpty(this.props.user)}
                                    />
                                }
                            </Grid>
                            <Grid item xs={12} sm={this.state.is_permanent ? 12 : 6}>
                                <Box p={1}>
                                    <DatePickerCmp  
                                        id="loan_start_date" 
                                        label="Date d'attribution" 
                                        name="loan_start_date" 
                                        value={this.state.loan_start_date} 
                                        handleChange={(option) => this.handleChangeDate("loan_start_date", option)} 
                                        error={this.state.errors.loan_start_date}
                                        required
                                        noPadding
                                    />      
                                </Box>
                            </Grid>   
                            {!this.state.is_permanent &&
                                <Grid item xs={12} sm={6}>
                                    <Box p={1}>
                                        <DatePickerCmp  
                                            id="loan_estimated_return" 
                                            label="Date de retour prévue" 
                                            name="loan_estimated_return" 
                                            value={this.state.loan_estimated_return} 
                                            handleChange={(option) => this.handleChangeDate("loan_estimated_return", option)} 
                                            error={this.state.errors.loan_estimated_return}
                                            required
                                            noPadding
                                        />      
                                    </Box>
                                </Grid>   
                            }
                            {/* { !isEmpty(this.state.loan_equipement) && 
                                <Fragment>
                                </Fragment>
                            } */}
                            
                            <Grid item xs={12}>
                                <hr />
                                <Box p={1}>
                                    <Typography color="primary" variant="button" style={{fontWeight: "bold"}}>Etat</Typography>
                                </Box>
                            </Grid>
                            <Grid item xs={12}>
                                <Box p={1}>
                                    <Alert severity="warning">
                                    
                                        <AlertTitle>
                                            Dernier Etat : {this.state.currentEquipement.equipement_state_current || this.state.currentEquipement.equipement_state}
                                        </AlertTitle>
                                        — {this.state.currentEquipement.equipement_remarks_current || this.state.currentEquipement.equipement_remarks}
                                    </Alert>
                                </Box>
                            </Grid>
                            {!this.props.resa &&
                            <>
                                <Grid item xs={12} sm={6} >
                                    <InputSelectNative
                                        labelWidth={60}
                                        onChange={ (e) => this.setState({ equipement_state_start: e.target.value })}
                                        error={this.state.errors.equipement_state_start}
                                        value={this.state.equipement_state_start}
                                        label="Etat Général"
                                        required
                                        options={[
                                            <option>Neuf</option>,
                                            <option>Bon</option>,
                                            <option>Moyen</option>,
                                            <option>Mauvais</option>,
                                        ]}
                                        
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} >
                                    <InputText
                                        onChange={this.handleChange}
                                        multiline
                                        required
                                        rows={2}
                                        id="equipement_remarks_start"
                                        error={this.state.errors.equipement_remarks_start}
                                        value={this.state.equipement_remarks_start}
                                        name="equipement_remarks_start"
                                        label="Remarques"
                                    />
                                </Grid>
                                { !isEmpty(this.state.loan_vehicule) &&                             
                                    <Fragment>
                                        <Grid item xs={12} sm={6}>
                                            <InputText
                                                onChange={this.handleChange}
                                                required
                                                id="loan_km_start"
                                                error={this.state.errors.loan_km_start}
                                                value={this.state.loan_km_start}
                                                name="loan_km_start"
                                                label="Kilométrage Départ (Km)"
                                                type="number"
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <InputText
                                                onChange={this.handleChange}
                                                required
                                                id="loan_fuel_start"
                                                error={this.state.errors.loan_fuel_start}
                                                value={this.state.loan_fuel_start}
                                                name="loan_fuel_start"
                                                label="Niveau Carburant (%)"
                                                type="number"
                                            />
                                        </Grid>
                                    </Fragment>
                                }
                                <Grid item xs={12}>
                                    <hr />
                                    <Box p={1}>
                                        <Typography color="primary" variant="button" style={{fontWeight: "bold"}}>Photos</Typography>
                                    </Box>
                                </Grid>
                                {[
                                    {title:"Face Avant", name:"front"}, 
                                    {title:"Face Arrière", name:"back"}, 
                                    {title:"Haut",name:"top"}, 
                                    {title:"Bas",name:"bottom"}, 
                                    {title:"Gauche",name:"left"}, 
                                    {title:"Droite",name:"right"}
                                ].map( side => 
                                    <Grid item xs={12} sm={6} >
                                        <Box p={1}>
                                            <PhotoUpload 
                                                id={side.name} 
                                                label={`Photo ${side.title}`} 
                                                setPhoto={(pic) => this.setPhotos(`loan_photo_${side.name}_start`, pic)} 
                                                photos={this.state[`loan_photo_${side.name}_start`] === null ? [] : this.state[`loan_photo_${side.name}_start`] }
                                                error={this.state.errors[`loan_photo_${side.name}_start`]}
                                            />
                                        </Box>
                                    </Grid>    
                                )}
                            </>
                            }
                    </Fragment>
                }
                </Grid>      
                
            </Dialog>
        );
    }
}

export default Attribution;


